import { render, staticRenderFns } from "./BookOfTheMonth.vue?vue&type=template&id=efde20c2&"
import script from "./BookOfTheMonth.vue?vue&type=script&lang=js&"
export * from "./BookOfTheMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports